import React from 'react';
import { cn } from '@/lib/utils';

type Props = {
    htmlTitle?: string;
    htmlSubTitle?: string;
    title?: string;
    subTitle?: string;
    className?: string;
}

export default function CampaignTabHeader({
    htmlTitle,
    htmlSubTitle,
    title,
    subTitle,
    className
}: Props) {
    return (
        <div className={cn("flex flex-col justify-center items-center mb-4", className)}>
            {htmlTitle ? (
                <div 
                    dangerouslySetInnerHTML={{ __html: htmlTitle }} 
                    className="text-center text-2xl font-bold mb-1.5 text-foreground dark:text-foreground"
                />
            ) : (
                <h1 className="text-center text-2xl font-bold mb-1.5 text-foreground dark:text-foreground">
                    {title}
                </h1>
            )}
            {htmlSubTitle ? (
                <div 
                    dangerouslySetInnerHTML={{ __html: htmlSubTitle }} 
                    className="text-center text-sm font-normal text-foreground dark:text-foreground"
                />
            ) : (
                <span className="text-center text-sm font-normal text-foreground dark:text-foreground">
                    {subTitle}
                </span>
            )}
        </div>
    )
}
